export default __webpack_public_path__ + "static/media/Logo.3f95e8cf.png";